const ByteUtils = {
    bytesToMebibyte: bytes => bytes >> 20,
    bytesToKibibyte: bytes => bytes >> 10,
    kibibyteToBytes: kibibyte => kibibyte << 10,
    mebibyteToBytes: mebibyte => mebibyte << 20,
    mebibyteToKibibyte: mebibyte => mebibyte >> 10,
    getUnit: bytes => bytes >= ByteUtils.mebibyteToBytes(1) ? 'MiB' : 'KiB',
    getDisplayUnit: bytes => bytes >= ByteUtils.mebibyteToBytes(1) ? 'MB' : 'KB'
}

export default ByteUtils;